module.exports = __webpack_public_path__ + "img/hero-planeta-zana.798f08e7.png";